(ns kyber.styles.typography)

(def line-height
  {:display-10 "1.2em"
   :display-20 "1.2em"
   :title-40 "1.2em"
   :title-30 "1.2em"
   :title-20 "1.2em"
   :title-10 "1.2em"
   :body-30 "1.5em"
   :body-20 "1.5em"
   :body-10 "1.5em"
   :caption-30 "1.2em"
   :caption-20 "1.2em"
   :caption-10 "1.2em"
   :icon "1em"})

(def display-10-size 19)
(def display-20-size 48)
(def title-40-size 24)
(def title-30-size 18)
(def title-20-size 15)
(def title-10-size 13)
(def body-30-size 16)
(def body-20-size 13)
(def body-10-size 12)
(def caption-30-size 13)
(def caption-20-size 12)
(def caption-10-size 11)
(def icon-sm-size 14)
(def icon-size 18)
(def icon-lg-size 28)
(def icon-xl-size 42)
(def icon-massive-size 85)

(defn ->rounded-px
  [display-value percent-change]
  (str (.toFixed (* display-value percent-change) 1) "px"))

(def size
  {:display-10 (->rounded-px display-10-size 1)
   :display-10/tablet (->rounded-px display-10-size 0.75)
   :display-10/mobile (->rounded-px display-10-size 0.58)

   :display-20 (->rounded-px display-20-size 1)
   :display-20/tablet (->rounded-px display-20-size 0.75)
   :display-20/mobile (->rounded-px display-20-size 0.58)

   :title-40 (->rounded-px title-40-size 1)
   :title-40/tablet (->rounded-px title-40-size 0.90)
   :title-40/mobile (->rounded-px title-40-size 0.82)

   :title-30 (->rounded-px title-30-size 1)
   :title-30/tablet (->rounded-px title-30-size 0.90)
   :title-30/mobile (->rounded-px title-30-size 0.82)

   :title-20 (->rounded-px title-20-size 1)
   :title-20/tablet (->rounded-px title-20-size 0.90)
   :title-20/mobile (->rounded-px title-20-size 0.82)

   :title-10 (->rounded-px title-10-size 1)
   :title-10/tablet (->rounded-px title-10-size 0.90)
   :title-10/mobile (->rounded-px title-10-size 0.82)

   :body-30 (->rounded-px body-30-size 1)
   :body-30/tablet (->rounded-px body-30-size 0.90)
   :body-30/mobile (->rounded-px body-30-size 0.82)

   :body-20 (->rounded-px body-20-size 1)
   :body-20/tablet (->rounded-px body-20-size 0.90)
   :body-20/mobile (->rounded-px body-20-size 0.82)

   :body-10 (->rounded-px body-10-size 1)
   :body-10/tablet (->rounded-px body-10-size 0.90)
   :body-10/mobile (->rounded-px body-10-size 0.82)

   :caption-30 (->rounded-px caption-30-size 1)
   :caption-30/tablet (->rounded-px caption-30-size 0.90)
   :caption-30/mobile (->rounded-px caption-30-size 0.82)

   :caption-20 (->rounded-px caption-20-size 1)
   :caption-20/tablet (->rounded-px caption-20-size 0.90)
   :caption-20/mobile (->rounded-px caption-20-size 0.82)

   :caption-10 (->rounded-px caption-10-size 1)
   :caption-10/tablet (->rounded-px caption-10-size 0.90)
   :caption-10/mobile (->rounded-px caption-10-size 0.82)

   :icon-sm (->rounded-px icon-sm-size 1)
   :icon-sm/tablet (->rounded-px icon-sm-size 0.90)
   :icon-sm/mobile (->rounded-px icon-sm-size 0.82)

   :icon (->rounded-px icon-size 1)
   :icon/tablet (->rounded-px icon-size 0.90)
   :icon/mobile (->rounded-px icon-size 0.82)

   :icon-lg (->rounded-px icon-lg-size 1)
   :icon-lg/tablet (->rounded-px icon-lg-size 0.90)
   :icon-lg/mobile (->rounded-px icon-lg-size 0.82)

   :icon-xl (->rounded-px icon-xl-size 1)
   :icon-xl/tablet (->rounded-px icon-xl-size 0.90)
   :icon-xl/mobile (->rounded-px icon-xl-size 0.82)

   :icon-massive (->rounded-px icon-massive-size 1)
   :icon-massive/tablet (->rounded-px icon-massive-size 0.75)
   :icon-massive/mobile (->rounded-px icon-massive-size 0.58)})

(def weight
  {:display-10 300
   :display-20 300
   :title-40 600
   :title-30 600
   :title-20 600
   :title-10 600
   :body-30 400
   :body-20 400
   :body-10 400
   :caption-30 600
   :caption-20 400
   :caption-10 400})

(def font-families
  {:open-sans "Open Sans, sans-serif"})
